import {useMutation} from '@apollo/react-hooks';

import type {
    DeleteNote as DeleteCommentMutation,
    DeleteNoteVariables as DeleteCommentMutationVariables,
} from 'nutshell-graphql-types';

import COMMENT_DELETE from '../../../timeline/comments/graphql/mutations/note-delete.graphql';

import ACTIVITY_MODAL_FRAGMENT from '../../graphql/fragments/activity-for-modal-fragment.graphql';

export function useDeleteComment(): (arg1: {
    activityId: string;
    commentId: string;
}) => Promise<any> {
    const [deleteComment] = useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(
        COMMENT_DELETE
    );

    return (commentInput: {activityId: string; commentId: string}) => {
        return deleteComment({
            variables: {input: {note: {id: commentInput.commentId}}},
            optimisticResponse: {
                noteDelete: {
                    __typename: 'DeleteNotePayload',
                    note: {
                        __typename: 'Note',
                        id: `temp-${Date.now()}-${Math.random()}`,
                        // @ts-expect-error
                        body: null,
                        bodyHtml: null,
                        bodyMarkup: null,
                        entity: null,
                        isEditable: false,
                        hasMentionedEntities: false,
                        htmlUrl: '',
                        htmlUrlPath: '',
                    },
                },
            },
            update: (proxy) => {
                const activityFragment = proxy.readFragment({
                    id: commentInput.activityId,
                    fragmentName: 'ActivityModalFragment',
                    fragment: ACTIVITY_MODAL_FRAGMENT,
                });

                // @ts-expect-error
                if (activityFragment && activityFragment.comments) {
                    proxy.writeFragment({
                        id: commentInput.activityId,
                        fragment: ACTIVITY_MODAL_FRAGMENT,
                        fragmentName: 'ActivityModalFragment',
                        data: {
                            ...activityFragment,
                            __typename: 'Activity',
                            comments: {
                                __typename: 'CommentsConnection',
                                // @ts-expect-error
                                totalCount: activityFragment.comments.totalCount - 1,
                                // @ts-expect-error
                                edges: activityFragment.comments.edges.filter(
                                    // @ts-expect-error
                                    (comment) => comment.node.id !== commentInput.commentId
                                ),
                            },
                        },
                    });
                }
            },
        });
    };
}
